import { useEffect } from "react";
import {
  isPushSupported,
  getNotificationPermission,
  subscribeToPush,
  registerServiceWorker,
  isPushSubscribedLocally,
} from "@/lib/pushNotifications";

/**
 * Silently registers the service worker and subscribes to push
 * when permission is already granted (e.g. user opted in via PushOptIn).
 */
export function usePushNotifications(enabled = true) {
  useEffect(() => {
    if (!enabled || !isPushSupported()) return;

    let cancelled = false;

    (async () => {
      try {
        await registerServiceWorker();
        if (cancelled) return;

        const permission = getNotificationPermission();
        if (permission === "granted" && !isPushSubscribedLocally()) {
          await subscribeToPush();
        }
      } catch {
        // Non-blocking — push is optional
      }
    })();

    return () => { cancelled = true; };
  }, [enabled]);
}

export default usePushNotifications;